// hooks/useSecureImage.ts
import { useState, useEffect } from 'react';
import { fetchMediaWithToken } from '../services/data/axios-base';

function useSecureFileEffect(url: string | null) {
  const [fileSrc, setFileSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (url == null) return;

    let objectURL: string | undefined;

    const loadImage = async () => {
      try {
        setLoading(true);
        setError(null);
        objectURL = await fetchMediaWithToken(url);
        setFileSrc(objectURL);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    loadImage();

    return () => {
      if (objectURL) URL.revokeObjectURL(objectURL);
    };
  }, [url]);

  return { fileSrc, loading, error };
}

export default useSecureFileEffect;
